import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";

import { api } from "@/APIRequests";
import { getQueryParams, uuidv4 } from "@/utils/filters";
import images from "@/utils/images";

import AccountLookup from "./AccountLookup";
import ChooseNewOrExistingMemberWorkflow from "./ChooseNewOrExistingMemberWorkflow";
import ConfirmIdentity from "./ConfirmIdentity";
import ConfirmInsurance from "./ConfirmInsurance/ConfirmInsurance";
import DemographicEligibilityCheck from "./DemographicEligbilityCheck";
import EnterOTC from "./EnterOTC";
import GenericWorkflowScreening from "./Screening/GenericWorkflowScreening";
import Ineligible from "./Ineligible";
import IntakeScheduling from "./IntakeScheduling";
import MemberAuth from "./MemberAuth";
import PracticeFailure from "./PracticeFailure";
import "./styles.scss";

global.workflowAuthIdToken = null;
global.workflowAuthAccessToken = null;
global.workflowAuthRefreshToken = null;

const Workflow = (props) => {
  const [sharedWorkflowData, setSharedWorkflowData] = useState({});
  const [currentStepName, setCurrentStepName] = useState(null);
  const practiceId = getQueryParams("practiceId", props.location.search);

  const backHandler = async () => {
    const options = { params: { showLoader: true } };
    const data = {
      workflow_instance_entity_id: sharedWorkflowData["workflow_instance"].entity_id,
      workflow_instance_sort_key: sharedWorkflowData["workflow_instance"]["sort_key"],
    };
    const headers = {
      "X-On-Behalf-Of": sharedWorkflowData["workflow_instance"].entity_id,
    };
    const response = await api.workflow.undo_state_and_backtrack_one_node({
      data,
      headers,
      options,
    });

    if (
      response["workflow_instance"].first_node ===
        response["workflow_instance"].current_node_name &&
      !response["workflow_instance"].previous_workflow
    ) {
      resetWorkflow();
    } else {
      setSharedWorkflowData({
        ...sharedWorkflowData,
        workflow_instance: response["workflow_instance"],
        workflow_instance_sort_key: response["workflow_instance"]["sort_key"],
      });
    }
  };

  const resetWorkflow = () => {
    window.location.reload();
  };

  const baseProps = {
    backHandler: backHandler,
    resetWorkflow: resetWorkflow,
    setSharedWorkflowData: setSharedWorkflowData,
    sharedWorkflowData: sharedWorkflowData,
  };

  const workflowSteps = {
    account_lookup: <AccountLookup {...baseProps} />,
    choose_workflow: <ChooseNewOrExistingMemberWorkflow {...baseProps} />,
    confirm_identity: <ConfirmIdentity {...baseProps} />,
    confirm_insurance: <ConfirmInsurance {...baseProps} />,
    demographic_data: <DemographicEligibilityCheck {...baseProps} />,
    ineligible: <Ineligible {...baseProps} />,
    member_auth: <MemberAuth {...baseProps} />,
    OTC: <EnterOTC {...baseProps} />,
    practice_failure: <PracticeFailure />,
    schedule_appointment: <IntakeScheduling {...baseProps} />,
    screening: <GenericWorkflowScreening {...baseProps} />,
  };

  useEffect(() => {
    (async () => {
      const options = { params: { showLoader: true } };

      if (!currentStepName) {
        const data = { practice_id: practiceId };
        const workflowResponse = await api.workflow.get_workflow({ data, options });

        if (workflowResponse) {
          const data = {
            entity_type: "session",
            workflow_config_entity_id: workflowResponse.entity_id,
            workflow_instance_entity_id: uuidv4(),
            workflow_name: workflowResponse.workflow_name,
          };
          const response = await api.workflow.create_workflow_instance({ data, options });

          setSharedWorkflowData({ ...sharedWorkflowData, workflow_instance: response });
        }
      } else if (
        !sharedWorkflowData.workflow_instance ||
        (currentStepName && !Object.hasOwn(workflowSteps, currentStepName))
      ) {
        setCurrentStepName(null);
        props.history.push(`/app/workflow?practiceId=${practiceId}`);
      }
    })();
  }, [currentStepName]);

  //display workflow step based on changes to workflow instance
  useEffect(() => {
    let stepName =
      sharedWorkflowData.workflow_instance &&
      sharedWorkflowData.workflow_instance.current_node_name;

    if (sharedWorkflowData.workflow_instance && !stepName) {
      stepName = sharedWorkflowData.workflow_instance.first_node;
    }
    if (stepName) {
      setCurrentStepName(stepName);
      props.history.push(`/app/workflow?practiceId=${practiceId}&step=${stepName}`);
    }
  }, [sharedWorkflowData.workflow_instance]);

  //display workflow step based on changes to nav buttons (go back/forward)
  useEffect(() => {
    const stepName = getQueryParams("step", props.location.search);

    if (
      !sharedWorkflowData.workflow_instance ||
      (stepName &&
        stepName !== currentStepName &&
        stepName === sharedWorkflowData.workflow_instance.first_node)
    ) {
      setCurrentStepName(null);
      setSharedWorkflowData({});
      props.history.push(`/app/workflow?practiceId=${practiceId}`);
    } else if (
      stepName &&
      stepName !== currentStepName &&
      stepName !== sharedWorkflowData.workflow_instance.first_node
    ) {
      setCurrentStepName(stepName);
      props.history.push(`/app/workflow?practiceId=${practiceId}&step=${stepName}`);
    }
  }, [getQueryParams("step", props.location.search)]);

  return (
    <>
      <div className="self-signup-content" style={{ overflowX: "hidden" }}>
        <div>
          <header className="brand-header" style={{ position: "relative" }}>
            <div className="brand-header-logo">
              <span className="logo-and-insurance" style={{ float: "none", margin: " auto" }}>
                <img
                  alt="aptihealth"
                  className="apti-img"
                  src={images("./common/apti_logo_w_tagline.svg")}
                />
              </span>
            </div>
          </header>

          {currentStepName &&
            Object.hasOwn(workflowSteps, currentStepName) &&
            workflowSteps[currentStepName]}
        </div>
      </div>
    </>
  );
};

export default withRouter(Workflow);
